(function($) {
    $.widget("ca.caDateSelector", {
        options: {
          year: (new Date()).getYear() + 1900
        },

        _create : function() {
            var year = this.options.year;           
            var element = this.element;
            var selectMonth = element.find('.month');
            selectMonth.change(function() {           
                var day = element.find('.day');
                var old_day = day.val();
                var monthVal = selectMonth.val();
                var month;
                if (monthVal.length > 2) {
                    if (monthVal.substr(5) == '0') {
                        month = monthVal.substr(6);
                    } else {
                        month = monthVal.substr(5, 2);
                    }
                } else {
                    month = monthVal;
                }
                var days = 32 - new Date(year, month - 1, 32).getDate();
                var options = '';
                for (var i = 1; i <= 9; i++) {
                    options += '<option ' + (i == old_day ? 'selected' : '') + ' value="0' + i + '" label="0' + i + '">0' + i + '</option>';
                }
                for (var i = 10; i <= days; i++) {
                    options += '<option ' + (i == old_day ? 'selected' : '') + ' value="' + i + '" label="' + i + '">' + i + '</option>';
                }
                day.html(options);
                $(day).trigger("chosen:updated");
            });
        }
    });
})(jQuery);